import { mustBeAdmin } from "../util/auth";

const Document = () => import("../components/content/document/document");
const EmployeeDocument = () =>
  import("../components/content/document/employeeDocument");

export const documentRoutes = {
  path: "/document",
  component: Document,
  children: [
    {
      path: "",
      component: EmployeeDocument
    }
  ],
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
